import PropTypes from 'prop-types';
import CheckoutFormAddress from './CheckoutFormAddress';
import CheckoutFormDelivery from './CheckoutFormDelivery';
import CheckoutFormPayment from './CheckoutFormPayment';
import CheckoutFormRetainedDetails from './CheckoutFormRetainedDetails';

function CheckoutForm({
  addressDeliveryLocked = false,
  deliveryUpdateState,
  onDeliveryUpdateStateChange,
  retainedAttempt = null,
  taxCheckoutEnabled = null,
}) {
  return (
    <div className="flex flex-col gap-y-2">
      {retainedAttempt ? (
        <CheckoutFormRetainedDetails
          addressDeliveryLocked={addressDeliveryLocked}
          retainedAttempt={retainedAttempt}
        />
      ) : (
        <CheckoutFormPayment />
      )}
      {addressDeliveryLocked ? null : (
        <>
          <CheckoutFormAddress />
          <CheckoutFormDelivery
            cartUpdatesLocked={Boolean(retainedAttempt)}
            taxCheckoutEnabled={taxCheckoutEnabled}
            deliveryUpdateState={deliveryUpdateState}
            onDeliveryUpdateStateChange={onDeliveryUpdateStateChange}
          />
        </>
      )}
    </div>
  );
}

CheckoutForm.propTypes = {
  addressDeliveryLocked: PropTypes.bool,
  deliveryUpdateState: PropTypes.shape({
    blocked: PropTypes.bool.isRequired,
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  onDeliveryUpdateStateChange: PropTypes.func.isRequired,
  retainedAttempt: PropTypes.shape({
    deliveryMethod: PropTypes.string,
    shippingAddress: PropTypes.object,
  }),
  taxCheckoutEnabled: PropTypes.bool,
};

export default CheckoutForm;
